<template>
    <div class="partyArticleListPage">
        <div class="background"></div>
        
        <div class="articleListPage">
        <hr />
        <div class="spanTotal">为您找到相关结果{{total}}个</div>
        <div>
            <a-list :loading="listLoading" item-layout="vertical" size="large" :pagination="pagination" :data-source="listData">
                <a-list-item class="renderItem" slot="renderItem" key="item.title" slot-scope="item">
                    <div @click="open(item)">
                        <h3>{{ item.title }}</h3>
                        <h5>{{ item.newCreateTime }}</h5>
                        <p>{{ item.mewContent }}...</p>
                    </div>
                </a-list-item>
            </a-list>
        </div>
        
        </div>
    </div>
</template>

<script>
import { getChildItem } from "@/api/index";
import { getNewsList } from "@/api/ArticleListPage";
import { getImgRegex, objectMerge } from "@/utils/index";
import { getHtml, setDateTime } from "@/utils/index";

export default {
    data() {
        return {
            id: '',
            total: 0,
            listData: [],
            pagination: {
                pageSize: 10,
            },
            listLoading: false
        };
    },
    created(){
        this.id = this.$route.params.id?this.$route.params.id:''
        this.getNewsList()
    },
    methods:{
        getNewsList(){
            this.listLoading = true
            getNewsList(this.id).then(res => {
                this.listLoading = false
                this.total = res.length
                res.data.forEach(element => {
                    element.newCreateTime = setDateTime(element.createTime)
                    element.mewContent = element.content?getHtml(element.content):''
                });
                this.listData = res.data
            })
        },
        open(row){
            window.open(`${window.location.origin}/#/ArticleInfo/${row.id}`, '_blank');
        }
    }
}
// export default {
//     data() {
//         return {
//             page1Obj:{},
//             page2Obj:{},
//             page3Obj:{},
//             page4Obj:{},
//         };
//     },
//     created(){
//         this.getChildItem()
//     },
//     methods:{
//         getChildItem(){
//             getChildItem('7F170C29B59B7E01E0532D0B000A8E43').then(res => {
//                 res.forEach((item, i) => {
//                     this.getNewsList(item,i)
//                 })
//             })
//         },
//         getNewsList(obj, index){
//             getNewsList(obj.id).then(res => {
//                 obj.list = res.data
//                 if(index == 0){
//                     this.page1Obj = obj
//                 }else if( index == 1){
//                     obj.list.forEach(item =>{
//                         item.bji = getImgRegex(item.content)
//                     })
//                     this.page2Obj = obj
//                 }else if(index== 2){
//                     this.page3Obj = obj
//                 }else if(index == 3){
//                     this.page4Obj = obj
//                 }
//             })
//         },
//         pageOpen(item, t){
//             if(t === 1){
//                 window.open(`${window.location.origin}/#/ArticleListPage/${item.id}`, '_blank')
//             }else{
//                 window.open(`${window.location.origin}/#/ArticleInfo/${item.id}`, '_blank')
//             }
//         },
//     }
// }
</script>

<style lang="less" scoped>
.partyArticleListPage{
    .background{
        width: 100%;
        vertical-align: top;
        background-size: cover;
        background-position: top;
        height: 800px;
        background-image: url('../assets/image/partyArticleListPage/partLoogImg.png');
    }
    .pageFirst{
        background-color: #fff;
        padding: 89px calc(50% - 600px);
        .firstList{
            flex: 1 1;
            .header{
                display: flex;
                justify-content: space-between;
                border-bottom: 3px solid #09f;
                border-bottom-color: rgb(204, 0, 0);
                >h1{
                    font-size: 24px;
                    color: #999;
                }
                .bt{
                    border-radius: 100px;
                    padding: 0 17px;
                    height: 24px;
                    border-color: rgb(204, 0, 0);
                    color: rgb(204, 0, 0);
                }
            }
            .articleItem{
                margin-top: 20px;
                >p{
                    color: rgb(204, 0, 0);
                    font-size: 16px;
                    cursor: pointer;
                }
                .div{
                    font-size: 14px;
                    color: #999;
                }
            }
        }
    }
    .page1{
        display: flex;
        justify-content: stretch;
        .pageImg{
            width: 567px;
            height: 372px;
            margin-right: 56px;
            background-size: cover;
            background-position: 50%;
            background-image: url('../assets/image/partyArticleListPage/63161684381500041.png');
        }
    }
    .page2{
        height: 240px;
        background-color: #f1f1f1;
        display: flex;
        align-items: center;
        .LoopContentLeft{
            display: inline-block;
            >h1{
                font-size: 36px;
                margin-bottom: 40px;
                color: #c00;
                border-bottom: 1px solid #c00;
            }
            .bt{
                border-radius: 100px;
                color: #fff;
                padding: 9px 20px;
                line-height: 1;
                transition: all .3s;
                font-weight: 700;
                border: 1px solid #c00;
                background-color: #c00;
            }
        }
        .LoopContentRight{
            margin-left: 77px;
            display: inline-block;
            flex: 1 1;
            width: 100px;
            .custom-slick-arrow {
                width: 32px;
                height: 32px;
                font-size: 35px;
                color: #ccc;
            }
            .custom-slick-arrow:first-child {
                left: -30px;
            }
            .custom-slick-arrow:last-child {
                right: -30px;
            }
            .custom-slick-arrow:before {
                display: none;
            }
            .custom-slick-arrow:hover {
                opacity: 0.5;
            }
            .carousel_view{
                cursor: pointer;
                width: 100%;
                display: inline-block;
                position: relative;
                padding-right: 20px;
                .LoopItemImg{
                    background-position: 50%;
                    background-size: cover;
                    height: 180px;
                }
                >span{
                    font-weight: 700;
                    font-size: 16px;
                    color: #fff;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    word-break: keep-all;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    background: linear-gradient(0deg, rgba(0, 0, 0, .6), transparent);
                    padding: 15px;
                    margin: 0 15px;
                }
            }
        }
    }
    .page3{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        background-color: #fff;
        padding: 89px calc(50% - 600px);
        .firstList{
            width: 540px;
            flex: 0 0 540px;
        }
    }

    .articleListPage{
        margin-top: 0px;
        background-color: #fff;
        padding: 50px calc(50% - 600px);
        >hr {
            background-color: #e6e6e6;
            height: 1px;
            margin: 45px 0;
            border: none;
        }
        .spanTotal{
            font-size: 16px;
            letter-spacing: 0;
            color: #d5d5d5;
            margin-bottom: 10px;
        }
        .renderItem{
            h3{
                font-size: 18px;
                font-weight: 400;
                color: #1890ff;
                color: #c00;
                cursor: pointer;
                margin-bottom: 26px;
            }
            h5{
                font-size: 16px;
                font-weight: 400;
                color: #ccc;
                float: right;
            }
            p{
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                color: #666;
            }
        }
    }    

}    
</style>